var wfb = {
    featureCookie: 'wfb_feature',
    postcodeCookie: 'wfb_postcode',
    shippingUrl: 'https://mp.villageorganic.co.uk/api/shopify/shipping/wholefoodsbox/calculate-shipping',
    shippingRequestId: 0,
    popup: null,
    form: null,
    input: null,
    error: null,

    init: function() {
        this.popup = document.getElementById('WfbPostcodePopup');
        this.form = document.getElementById('WfbPostcodeForm');
        this.input = document.getElementById('WfbPostcodeInput');
        this.error = document.querySelector('[data-wfb-postcode-error]');

        document.addEventListener('dblclick', function(event) {
            if (event.target.closest('.icon--payment')) {
                console.log('wfb-button clicked');
                wfb.setCookie(wfb.featureCookie, '1');
                wfb.onFeatureEnabled();
            }
        });

        if (this.form) {
            this.form.addEventListener('submit', function(event) {
                event.preventDefault();
                wfb.saveTypedPostcode();
            });
        }

        document.querySelectorAll('[data-wfb-postcode-close]').forEach(function(el) {
            el.addEventListener('click', function() {
                wfb.hidePopup();
            });
        });

        document.addEventListener('click', function(event) {
            if (event.target.closest('[data-wfb-change-postcode]')) {
                event.preventDefault();
                wfb.showPopup();
            }
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                wfb.hidePopup();
            }
        });

        document.addEventListener('cart:updated', function(event) {
            if (!wfb.isFeatureEnabled()) {
                return;
            }

            wfb.calculateShipping(event.detail && event.detail.cart);
        });

        document.addEventListener('ajaxProduct:added', function() {
            if (!wfb.isFeatureEnabled()) {
                return;
            }

            wfb.refreshShipping();
        });

        document.addEventListener('CartDrawer:open', function() {
            if (!wfb.isFeatureEnabled()) {
                return;
            }

            wfb.refreshShipping();
        });

        if (this.isFeatureEnabled()) {
            this.onFeatureEnabled();
        }
    },

    onFeatureEnabled: function() {
        this.syncKnownPostcode();
        this.applyPostcodeToCart();

        if (!this.getDeliveryPostcode()) {
            this.showPopup();
        }
    },

    isFeatureEnabled: function() {
        return this.getCookie(this.featureCookie) === '1';
    },

    customerPostcode: function() {
        if (!this.popup) {
            return '';
        }

        return (this.popup.getAttribute('data-customer-postcode') || '').trim();
    },

    getDeliveryPostcode: function() {
        return this.getCookie(this.postcodeCookie) || this.customerPostcode();
    },

    syncKnownPostcode: function() {
        var knownPostcode = this.customerPostcode();

        if (!knownPostcode) {
            return;
        }

        this.setCookie(this.postcodeCookie, this.formatPostcode(knownPostcode), 365);
    },

    saveTypedPostcode: function() {
        var postcode = this.formatPostcode(this.input ? this.input.value : '');

        if (!this.isValidUkPostcode(postcode)) {
            this.toggleError(true);
            if (this.input) {
                this.input.focus();
            }
            return;
        }

        this.toggleError(false);
        this.setCookie(this.postcodeCookie, postcode, 365);
        this.applyPostcodeToCart();
        this.hidePopup();
    },

    applyPostcodeToCart: function() {
        var postcode = this.getDeliveryPostcode();

        if (!postcode) {
            return;
        }

        this.updatePostcodeUi(postcode);

        this.getCart()
            .then(function(cart) {
                var current = cart.attributes && cart.attributes.delivery_postcode;

                if (current === postcode) {
                    return cart;
                }

                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            delivery_postcode: postcode
                        }
                    })
                }).then(function(response) {
                    return response.json();
                });
            })
            .then(function(cart) {
                wfb.calculateShipping(cart);
            })
            .catch(function() {});
    },

    updatePostcodeUi: function(postcode) {
        document.querySelectorAll('[data-wfb-postcode-input]').forEach(function(input) {
            input.value = postcode;
        });

        document.querySelectorAll('[data-wfb-postcode-label]').forEach(function(label) {
            label.textContent = postcode;
        });

        document.querySelectorAll('[data-wfb-cart-shipping]').forEach(function(row) {
            row.hidden = false;
        });

        document.querySelectorAll('[data-wfb-shipping-at-checkout]').forEach(function(row) {
            row.hidden = true;
        });
    },

    getCart: function() {
        return fetch('/cart.js?t=' + Date.now(), {
            credentials: 'same-origin',
            cache: 'no-store'
        }).then(function(response) {
            return response.json();
        });
    },

    refreshShipping: function() {
        if (!this.getDeliveryPostcode()) {
            return;
        }

        this.getCart()
            .then(function(cart) {
                wfb.calculateShipping(cart);
            })
            .catch(function() {});
    },

    calculateShipping: function(cart) {
        var postcode = this.getDeliveryPostcode();

        if (!postcode) {
            return;
        }

        this.updatePostcodeUi(postcode);

        if (!cart || cart.status || !Array.isArray(cart.items)) {
            this.refreshShipping();
            return;
        }

        if (!cart.items.length) {
            this.renderShipping({
                success: true,
                rate: {
                    allow_shipping: true,
                    cost: 0,
                    breakdown: {
                        message: ''
                    }
                }
            });
            return;
        }

        var requestId = ++this.shippingRequestId;
        this.setShippingLoading();

        fetch(this.shippingUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                rate: {
                    destination: {
                        postal_code: postcode
                    },
                    items: cart.items.map(function(item) {
                        return {
                            name: item.product_title || item.title || item.name,
                            sku: item.sku,
                            quantity: item.quantity,
                            grams: item.grams,
                            price: item.price,
                            vendor: item.vendor,
                            requires_shipping: item.requires_shipping,
                            taxable: item.taxable,
                            fulfillment_service: item.fulfillment_service || 'manual',
                            properties: item.properties || {},
                            product_id: item.product_id,
                            variant_id: item.variant_id
                        };
                    })
                }
            })
        })
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                if (requestId !== wfb.shippingRequestId) {
                    return;
                }

                wfb.renderShipping(data);
            })
            .catch(function() {
                if (requestId !== wfb.shippingRequestId) {
                    return;
                }

                wfb.renderShipping({
                    success: false,
                    error: 'Unable to calculate shipping. Please try again.'
                });
            });
    },

    setShippingLoading: function() {
        document.querySelectorAll('[data-wfb-shipping-fee], [data-wfb-shipping-cost]').forEach(function(el) {
            el.textContent = 'Calculating...';
            el.classList.add('is-loading');
        });

        document.querySelectorAll('[data-wfb-shipping-surcharge-row], [data-wfb-shipping-total-row]').forEach(function(el) {
            el.hidden = true;
        });

        document.querySelectorAll('[data-wfb-shipping-message]').forEach(function(el) {
            el.hidden = true;
            el.textContent = '';
            el.classList.remove('is-error');
        });

        this.toggleFreeShippingBanner(false);
    },

    renderShipping: function(data) {
        var rate = (data && data.rate) || {};
        var breakdown = rate.breakdown || {};
        var allowed = !!(data && data.success && rate.allow_shipping);
        var message = '';
        var isError = false;
        var feeLabel = 'Free';
        var surchargeAmount = Number(breakdown.surcharge_cost);
        var showSurcharge = Number.isFinite(surchargeAmount) && surchargeAmount > 0;
        var totalLabel = 'Free';

        if (!data || !data.success) {
            message = (data && data.error) || 'Unable to calculate shipping. Please try again.';
            isError = true;
            feeLabel = '—';
            totalLabel = '—';
            showSurcharge = false;
        } else if (!rate.allow_shipping) {
            message = rate.message || breakdown.message || 'Shipping is not available for this basket.';
            isError = true;
            feeLabel = 'Unavailable';
            totalLabel = 'Unavailable';
            showSurcharge = false;
        } else {
            feeLabel = this.formatShippingAmount(
                breakdown.shipping_cost != null ? breakdown.shipping_cost : rate.cost
            );
            totalLabel = this.formatShippingAmount(rate.cost);
            message = breakdown.message || rate.message || '';
        }

        document.querySelectorAll('[data-wfb-shipping-fee-label]').forEach(function(el) {
            el.textContent = showSurcharge ? 'Shipping fee' : 'Shipping';
        });

        document.querySelectorAll('[data-wfb-shipping-fee]').forEach(function(el) {
            el.textContent = feeLabel;
            el.classList.remove('is-loading');
        });

        document.querySelectorAll('[data-wfb-shipping-surcharge]').forEach(function(el) {
            el.textContent = showSurcharge ? wfb.formatShippingMoney(surchargeAmount) : '';
        });

        document.querySelectorAll('[data-wfb-shipping-surcharge-row], [data-wfb-shipping-total-row]').forEach(function(el) {
            el.hidden = !showSurcharge;
        });

        document.querySelectorAll('[data-wfb-shipping-cost]').forEach(function(el) {
            el.textContent = totalLabel;
            el.classList.remove('is-loading');
        });

        document.querySelectorAll('[data-wfb-shipping-message]').forEach(function(el) {
            el.textContent = message;
            el.hidden = !message;
            el.classList.toggle('is-error', isError);
        });

        this.renderFreeShippingBanner(data, rate, isError);
        this.setCheckoutEnabled(allowed || !(data && data.success));
    },

    renderFreeShippingBanner: function(data, rate, isError) {
        var remaining = rate.remaining_to_free;
        if (remaining == null && data) {
            remaining = data.remaining_to_free;
        }

        var remainingAmount = Number(remaining);
        var showBanner = !isError && Number.isFinite(remainingAmount) && remainingAmount > 0 && !rate.is_free_shipping;

        this.toggleFreeShippingBanner(
            showBanner,
            showBanner ? 'Spend ' + this.formatShippingMoney(remainingAmount) + ' more to get free shipping.' : ''
        );
    },

    toggleFreeShippingBanner: function(show, text) {
        document.querySelectorAll('[data-wfb-free-shipping-banner]').forEach(function(el) {
            el.textContent = show ? (text || '') : '';
            el.hidden = !show;
        });

        this.updateTopAnnouncement(show, text);
    },

    updateTopAnnouncement: function(show, text) {
        var toolbar = document.querySelector('.toolbar');
        var contents = document.querySelectorAll('.announcement-slider__content');

        if (!toolbar || !contents.length) {
            return;
        }

        if (!this.originalAnnouncements) {
            this.originalAnnouncements = [];
            contents.forEach(function(el) {
                wfb.originalAnnouncements.push(el.innerHTML);
            });
        }

        if (show && text) {
            contents.forEach(function(el) {
                el.innerHTML = '<p>' + text + '</p>';
            });
            toolbar.classList.add('wfb-toolbar--spend-more');
            return;
        }

        contents.forEach(function(el, index) {
            if (wfb.originalAnnouncements[index] != null) {
                el.innerHTML = wfb.originalAnnouncements[index];
            }
        });
        toolbar.classList.remove('wfb-toolbar--spend-more');
    },

    formatShippingAmount: function(amount) {
        if (amount === undefined || amount === null || amount === '' || Number(amount) === 0) {
            return 'Free';
        }

        return this.formatShippingMoney(amount);
    },

    setCheckoutEnabled: function(enabled) {
        document.querySelectorAll('.cart__checkout').forEach(function(button) {
            button.disabled = !enabled;
        });

        document.querySelectorAll('.additional-checkout-buttons').forEach(function(el) {
            el.style.display = enabled ? '' : 'none';
        });
    },

    formatShippingMoney: function(pounds) {
        var amount = Number(pounds);

        if (isNaN(amount)) {
            amount = 0;
        }

        return '£' + amount.toFixed(2);
    },

    showPopup: function() {
        if (!this.popup) {
            return;
        }

        if (this.input) {
            this.input.value = this.getDeliveryPostcode();
            this.toggleError(false);
        }

        this.popup.hidden = false;
        this.popup.classList.add('is-open');
        document.body.classList.add('wfb-postcode-popup-open');

        if (this.input) {
            this.input.focus();
        }
    },

    hidePopup: function() {
        if (!this.popup) {
            return;
        }

        this.popup.hidden = true;
        this.popup.classList.remove('is-open');
        document.body.classList.remove('wfb-postcode-popup-open');
    },

    toggleError: function(show) {
        if (!this.error) {
            return;
        }

        this.error.hidden = !show;
    },

    isValidUkPostcode: function(value) {
        return /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/.test(this.formatPostcode(value));
    },

    formatPostcode: function(value) {
        var cleaned = String(value || '').replace(/\s+/g, '').toUpperCase();

        if (cleaned.length < 5) {
            return cleaned;
        }

        return cleaned.slice(0, -3) + ' ' + cleaned.slice(-3);
    },

    getCookie: function(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));

        return match ? decodeURIComponent(match[1]) : '';
    },

    setCookie: function(name, value, days) {
        var cookie = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';

        if (days) {
            cookie += '; max-age=' + (days * 24 * 60 * 60);
        }

        document.cookie = cookie;
    }
};

document.addEventListener('DOMContentLoaded', function() {
    wfb.init();
});
